import React from "react";
import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";

import { useRootAppStore } from "@hooks";
import { analyticsTracker } from "@utils/analytics";
import InfoMessageComponent from "@components-shared/InfoMessageComponent";
import { BetBuilderPickActionsTypeEnum } from "@data-types/analytics-tracker/QuickPlayInteractionTypeEnum";

import { BetBuilderPicksCard } from "./components";

import BetBuilderPicksFilterBar from "./components/BetBuilderPicksFilterBar";
import QuickPlayPageContentLoader from "../common/QuickPlayPageContentLoader";

import { useScrollRestoration } from "@hooks/useScrollRestoration";
import { ConfigType } from "@data-types/use-scroll-restoration/useScrollRestoration";
import QuickPlayEventResultAndTime from "@features/quick-play/shared/QuickPlayEventResultAndTime";

export default observer(function BetBuilderPicksPage() {
	const rootStore = useRootAppStore();
	const { t } = useTranslation();

	useScrollRestoration({ type: ConfigType.Basic });

	if (rootStore.quickPlayStore.shouldShowLoader) {
		return <QuickPlayPageContentLoader />;
	}
	if (rootStore.quickPlayStore.shouldShowEmptyState) {
		return (
			<div className="card--primary__body">
				<InfoMessageComponent
					type="note"
					message={t(
						"QUICK_PLAY.BET_BUILDER_PICKS.PICKS_EMPTY_STATE"
					)}
				/>
			</div>
		);
	}

	return (
		<div className="card--primary__body">
			<BetBuilderPicksFilterBar />
			<div className="row row--gap--xsml">
				{rootStore.quickPlayStore.betBoosterStore.hubData.betBuilderPresetIds.map(
					(item, index) => {
						const slip =
							rootStore.quickPlayStore.betBuilderPicksStore.BBPicks.get(
								item
							);
						if (!slip) {
							return null;
						}

						const event =
							rootStore.quickPlayStore.betBoosterStore.eventsResultHubStore.getEvent(
								slip.eventId
							);
						return (
							<div key={slip.id} className="col col-sml-6">
								<div
									onClick={(e) => {
										analyticsTracker.trackQuickPlayInteraction(
											BetBuilderPickActionsTypeEnum.PickClick
										);
										rootStore.quickPlayStore.betBuilderPicksStore.activatePopup(
											slip.id,
											index,
											true
										);
									}}
									className="card card--qp card--qp--nowrap card--qp--hover card--bbp card--bbp--nowrap"
								>
									<div className="card__header card--bbp__header u-padd--reset">
										<QuickPlayEventResultAndTime
											event={event}
											startTime={slip.startTime}
										/>

										{slip.isLive && (
											<span className="card--pick__tag tag tag--tny tag--live--ghost tag--bolder">
												{t<string>("COMMON.LIVE")}
											</span>
										)}
									</div>

									<div className="card--qp__body card--bbp__body">
										<BetBuilderPicksCard
											BBPick={slip}
											maxOffers={3}
											key={slip.id}
										/>
									</div>
								</div>
							</div>
						);
					}
				)}
			</div>
		</div>
	);
});
